import { render, staticRenderFns } from "./lotto-summary.vue?vue&type=template&id=59974b9f&"
import script from "./lotto-summary.vue?vue&type=script&lang=js&"
export * from "./lotto-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports